import { render, staticRenderFns } from "./Pricelist.vue?vue&type=template&id=f36a1224&scoped=true"
import script from "./Pricelist.vue?vue&type=script&lang=js"
export * from "./Pricelist.vue?vue&type=script&lang=js"
import style0 from "./Pricelist.vue?vue&type=style&index=0&id=f36a1224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36a1224",
  null
  
)

export default component.exports